import { motion } from "framer-motion";
import { ShieldCheck, Clock, MapPin, Award } from "lucide-react";

const features = [
  {
    icon: Award,
    title: "Certificación Técnica",
    description:
      "Nuestro equipo cuenta con certificaciones internacionales y experiencia en los últimos estándares de telecomunicaciones.",
    color: "from-blue-500 to-accent",
  },
  {
    icon: Clock,
    title: "Respuesta Rápida",
    description:
      "Atención y resolución de incidentes en tiempo récord. Soporte técnico de lunes a viernes con seguimiento del proyecto.",
    color: "from-accent to-cyan-400",
  },
  {
    icon: MapPin,
    title: "Cobertura AMBA",
    description:
      "Operamos en todo el Área Metropolitana de Buenos Aires con flota propia y equipos listos para despliegue inmediato.",
    color: "from-primary to-blue-600",
  },
  {
    icon: ShieldCheck,
    title: "Garantía de Instalación",
    description:
      "Todas nuestras instalaciones están certificadas y cuentan con garantía de calidad. Documentación técnica entregada.",
    color: "from-indigo-500 to-primary",
  },
];

export const WhyUs = () => {
  return (
    <section
      data-testid="whyus-section"
      className="py-24 md:py-32 bg-[#F5F5F5] relative overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-full h-full opacity-5"
        style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23003366' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")" }} />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-accent font-heading font-semibold text-sm tracking-widest uppercase block mb-3">
            Por qué elegirnos
          </span>
          <h2 className="font-heading font-black text-primary text-4xl md:text-5xl mb-4">
            Nuestros Diferenciales
          </h2>
          <p className="font-body text-gray-500 text-lg max-w-xl mx-auto">
            Lo que nos hace diferentes en el mercado de telecomunicaciones
          </p>
          <div className="w-20 h-1 bg-accent mx-auto mt-6 rounded-full" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, i) => {
            const Icon = feat.icon;
            return (
              <motion.div
                key={feat.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.12, duration: 0.6 }}
                data-testid={`whyus-card-${i}`}
                className="group bg-white rounded-2xl p-8 border border-gray-100 shadow-[0_4px_20px_-2px_rgba(0,0,0,0.06)] hover:-translate-y-2 hover:shadow-[0_20px_40px_-4px_rgba(0,174,239,0.15)] hover:border-accent/30 transition-all duration-300 text-center"
              >
                <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${feat.color} flex items-center justify-center mx-auto mb-5 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                  <Icon size={28} className="text-white" />
                </div>
                <h3 className="font-heading font-bold text-primary text-lg mb-3">
                  {feat.title}
                </h3>
                <p className="font-body text-gray-500 text-sm leading-relaxed">
                  {feat.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
